import AppGuidedTour from './AppGuidedTour.component';

export default AppGuidedTour;
